import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelActivity\CreateModelActivityController::__invoke
* @see app/Http/Controllers/ModelActivity/CreateModelActivityController.php
* @route '/api/model-activity'
*/
const CreateModelActivityController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelActivityController.url(options),
    method: 'post',
})

CreateModelActivityController.definition = {
    methods: ["post"],
    url: '/api/model-activity',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelActivity\CreateModelActivityController::__invoke
* @see app/Http/Controllers/ModelActivity/CreateModelActivityController.php
* @route '/api/model-activity'
*/
CreateModelActivityController.url = (options?: RouteQueryOptions) => {
    return CreateModelActivityController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelActivity\CreateModelActivityController::__invoke
* @see app/Http/Controllers/ModelActivity/CreateModelActivityController.php
* @route '/api/model-activity'
*/
CreateModelActivityController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelActivityController.url(options),
    method: 'post',
})

export default CreateModelActivityController